import axios from "axios";
import Cookies from "js-cookie";

const GetUser = async () => {
    try {
        const headers = { "Authorization": "BEARER authToken=" + Cookies.get('skyarc-auth-8080'), "Accept":"application/json" }    
        const userDataResponse = await axios.get('https://infinity.skyspark.nl/api/portal/eval?expr=inf_api_user_Copy()', {headers})
        if(userDataResponse.status === 200) return userDataResponse
        else return []
    } catch(error) {
        return []
    }
}

export default GetUser;